__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/6c8b7db/_next/";